import { USERS_DASHBOARD } from "../../constants/routes";

const HeaderUsersTitle = () => {
    return (
        <div className="flex flex-row items-center">
            <a href={USERS_DASHBOARD} className="mr-[16px] ">
                <h1 className="text-[#E6BE40] font-normal text-[24px] xl:text-[28px]">ユーザーマスタ</h1>
            </a>
        </div>
    );
};

export default HeaderUsersTitle;